import { render } from "./editForm.vue?vue&type=template&id=350b54dd&scoped=true"
import script from "./editForm.js?vue&type=script&lang=js"
export * from "./editForm.js?vue&type=script&lang=js"

import "./editForm.vue?vue&type=style&index=0&id=350b54dd&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-350b54dd"]])

export default __exports__